import React from 'react'
import { Box } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ErrorBoundary from '../../../../components/Common/ErrorBoundary';

const SingleValueWithDetailKPI = ({
    handleModalShow,
    widgetConfig,
    widgetData
}) => {
  const { WidgetName = 'Single KPI Detailed', WidgetColor = '#4dd0e1', Datapoints, icon: Icon, Entity = '', WidgetID = ''} = widgetConfig || {}
  const { WidgetData = {} } = widgetData || {}

  const datapointsArr = Array.isArray(Datapoints) && Datapoints.length === 2 ? Datapoints : ['', ''];
  const [key, detailedKey] = datapointsArr;

  const value = WidgetData && Object.prototype.hasOwnProperty.call(WidgetData, key) ? WidgetData[key] : '';
  const detailValue = WidgetData && Object.prototype.hasOwnProperty.call(WidgetData, detailedKey) ? WidgetData[detailedKey] : '';

  const handleClick = (clickedKey, clickedValue) => {
    if (handleModalShow) {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const dd = String(today.getDate()).padStart(2, '0');
      const csvFileName = `${key.toLowerCase()}_data_${yyyy}-${mm}-${dd}`;
      handleModalShow({ 'EntityType': clickedKey }, Entity, WidgetID, csvFileName);
    }
  };

  return (
    <ErrorBoundary>
      <div
        className="systemHealth m-0 p-0 WidgetPadding"
        key={`widget-${WidgetID}`}
      >
        <Box
          className="SingleDetailBox"
          sx={{
            height: 8,
            backgroundColor: WidgetColor,
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
          }}
        />
        <div style={{ margin: "10px" }}>
          <>
            <div style={{ display: "flex" }}>
              {Icon && (
                <Icon
                  className=""
                  style={{ color: WidgetColor, height: "3rem", width: "3rem" }}
                />
              )}
              <div className="ml-3">
                <p className="singleKpiText singleKpiHeader">{WidgetName}</p>
                <div
                  className="singleKpiText singleValue"
                  style={{ cursor: handleModalShow ? "pointer" : "default" }}
                  onClick={() => handleClick(key, value)}
                >
                  {value}
                </div>
              </div>
            </div>
            <div className="singleDetailLabelValue">
              <div className="singleDetailValueBox">
                <p className="mb-0" style={{ fontSize: "16px" }}>
                  {detailedKey}
                </p>
                :
                <p
                  className="mb-0 singleKpiText singleValuedetail"
                  style={{ cursor: handleModalShow ? "pointer" : "default" }}
                  onClick={() => handleClick(detailedKey, detailValue)}
                >
                  {detailValue}
                </p>
              </div>
            </div>
          </>
        </div>
      </div>
    </ErrorBoundary>
  );
}

export default SingleValueWithDetailKPI